var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMuteButtonBaseOver(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48.436,
    height: 48.436,
    viewBox: "0 0 48.436 48.436",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_15504",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 15504",
    transform: "translate(-1231 -285.484)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u524D\\u9762\\u30AA\\u30D6\\u30B8\\u30A7\\u30AF\\u30C8\\u3067\\u578B\\u629C\\u304D_5",
    "data-name": "\\u524D\\u9762\\u30AA\\u30D6\\u30B8\\u30A7\\u30AF\\u30C8\\u3067\\u578B\\u629C\\u304D 5",
    d: "M-8195.568-21048.566H-8244V-21097h48.436v48.436h0Zm-24.295-44.744a8.146,8.146,0,0,0-8.139,8.139v10.164a8.145,8.145,0,0,0,8.139,8.133v.01a8.152,8.152,0,0,0,8.138-8.143v-10.166A8.148,8.148,0,0,0-8219.863-21093.311Z",
    transform: "translate(9475 21382.484)",
    fill: "#323232"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_20330",
    "data-name": "\\u30D1\\u30B9 20330",
    d: "M33.474,12.034a2.034,2.034,0,1,0-4.068,0,10.17,10.17,0,1,1-20.339,0,2.034,2.034,0,1,0-4.068,0A14.237,14.237,0,0,0,17.2,26.108v4.23H12.912a1.81,1.81,0,0,0-1.81,1.81V32.6a1.81,1.81,0,0,0,1.81,1.81H25.563a1.81,1.81,0,0,0,1.81-1.81v-.447a1.81,1.81,0,0,0-1.81-1.81H21.271v-4.23a14.237,14.237,0,0,0,12.2-14.079Z",
    transform: "translate(1236.002 295.766)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMuteButtonBaseOver);
export default __webpack_public_path__ + "static/media/muteButtonBaseOver.746973274f05847a5369959182406ca2.svg";
export { ForwardRef as ReactComponent };